export interface Item {
  id: string;
  name: string;
  description: string;
  initialPrice: number;
  quantity: number;
  category: string;
  currency: string;
}

export interface BidHistory {
  id: string;
  vendorName: string;
  /** Snapshot of users.company at the time the bid was placed */
  vendorCompanyName?: string | null;
  amount: number;
  timestamp: string | Date;
}

export interface BidAttachment {
  id?: string;
  fileName: string;
  fileUrl: string;
  fileSizeBytes?: number | null;
}

export enum BidStatus {
  UPCOMING = 'UPCOMING',
  LIVE = 'LIVE',
  ENDED = 'ENDED',
}

export interface Bid {
  id: string;
  creatorId: string;
  creatorName?: string;
  /** Creator's profile company (`users.company`); shown on cards as "Created By" */
  creatorCompanyName?: string | null;
  creatorEmail?: string;
  title: string;
  item: Item;
  startTime: string | Date;
  endTime: string | Date;
  durationMinutes: number;
  currentLowestBid: number;
  currentWinner: string | null;
  status: BidStatus;
  history: BidHistory[];
  decrementalPercentage: number;
  rankOnlyMode?: boolean;
  attachments?: BidAttachment[];
  invitedEmails?: string[];
  ccEmail?: string;
  attachmentName?: string;
  attachmentUrl?: string;
}

export interface UserSubscriptionSummary {
  plan: 'PREMIUM' | 'PRO';
  endDate: string;
  active: boolean;
}

export interface User {
  id: string;
  name: string;
  role: 'PROCUREMENT' | 'VENDOR';
  email: string;
  plan: 'FREE' | 'PREMIUM' | 'PRO';
  subscription?: UserSubscriptionSummary | null;
  birthday?: string;
  company?: string;
  designation?: string;
  mobile?: string;
  avatar?: string;
}

export interface ApiResponse<T> {
  success: boolean;
  data?: T;
  error?: string;
  message?: string;
}

export interface LoginRequest {
  email: string;
  password: string;
}

export interface LoginResponse {
  user: User;
  token: string;
  refreshToken: string;
}

export interface CreateBidRequest {
  title: string;
  item: Omit<Item, 'id'>;
  startTime: string;
  durationMinutes: number;
  decrementalPercentage: number;
  rankOnlyMode?: boolean;
  attachments?: BidAttachment[];
  invitedEmails: string[];
  ccEmail?: string;
  attachmentUrl?: string;
  attachmentName?: string;
}

export interface BidSummaryResponse {
  summary: string;
  totalSavings: number;
  percentageSaved: number;
  recommendation: string;
}
